import React from "react";
import logo from "../../assets/company-logo-w.svg";

const LogoLabel = () => {
  return (
    <div className="d-flex justify-content-center my-1">
      <img src={logo} style={{ height: "35px" }} alt="logo" />
    </div>
  );
};

export default LogoLabel;
